// src/actions/groupReportActions.js
import api from '../utils/api';

export const FETCH_GROUP_REPORTS_SUCCESS = 'FETCH_GROUP_REPORTS_SUCCESS';
export const UPDATE_GROUP_REPORT_SUCCESS = 'UPDATE_GROUP_REPORT_SUCCESS';

export const fetchGroupReports = (date) => async (dispatch) => {
  try {
    const res = await api.get(`/group-reports/date/${date}`);
    dispatch({
      type: FETCH_GROUP_REPORTS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching group reports:', error);
    // Handle error
  }
};

export const updateGroupReport = (groupReportData) => async (dispatch) => {
  try {
    const res = await api.post('/group-reports', groupReportData);
    dispatch({
      type: UPDATE_GROUP_REPORT_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.error('Error updating group report:', error);
    throw error;
  }
};
